let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bf0qg")).then(() => parcelRequire('67qr8'));